<div class="card" [ngClass]="{ 'remove-spacing': removeSpacing }">
  <div class="form-container">
    <div
      class="instruction-container"
      [ngClass]="getPosition(formConfig?.instructionPosition)"
    >
      <h2 class="card-header header-text">{{ formConfig.formTitle }}</h2>
      <ng-container *ngIf="formConfig.instructionText">
        <div class="instruction-text">
          {{ formConfig.instructionText }}
        </div>
      </ng-container>
    </div>
    <form [formGroup]="form" (ngSubmit)="submit()">
      <ng-container *ngIf="formConfig.controls.length">
        <ng-container
          *ngFor="
            let field of formConfig.controls;
            trackBy: 'name' | trackByKey
          "
          appDynamicField
          [currentImageFile]="currentImageFile"
          [fieldConfig]="field"
          [formConfig]="formConfig"
          [group]="form"
        ></ng-container>
      </ng-container>
      <app-save-cancel
        class="save-cancel-container"
        [buttonConfig]="formConfig.submit"
        [form]="form"
        [shouldDisable]="!form.valid"
        (emitSubmit)="submit()"
      ></app-save-cancel>
    </form>
  </div>
</div>
